import './StandOut.css';

import { MdOutlinePrivacyTip, MdOutlineWatchLater } from 'react-icons/md';
import { IoSettingsOutline } from 'react-icons/io5';
import { PiUsersThree } from 'react-icons/pi';
import {
  ClockCircleOutlined,
  SafetyCertificateOutlined,
  SettingOutlined,
  TeamOutlined,
} from "@ant-design/icons";

const StandOut: React.FC = () => {
  return (
    <div className="standoutContainer">
      <div className="standoutContent">
        <div className="standoutHeader">
          <h3 className="text-[27px]">What Makes Ease Margin Stand Out?</h3>
          <p className="text-[16px]">
            Track your profits in real-time and make smarter pricing decisions. Easy Margin
            helps you grow without the guesswork.
          </p>
        </div>
      </div>

      <div className="standoutMain">
        <div className="easyInterface">
          <h4 className="mb-2 text-base">Easy User Interface</h4>
          <p className="font-normal">
            User-Friendly and easy-to-navigate interface. <br /> Software implementation in just
            15 days without any charges.
          </p>
        </div>

        <div className="customizeContainer">
          <div className="customize">
            <h4 className="mb-2 text-base">Customization</h4>
            <p className="font-normal">
              Flexibility in customization processes and workflow. Data mapping from one document
              to another is used to automate the process.
            </p>
          </div>
          <div className="customizeCard md:h-38 md:text-sm text-xs">
            <div className="md:h-12">
                {/* <ClockCircleOutlined className="mt-2" /> */}
              <p>24/7 Intelligent Support</p>
            </div>
            <div className="md:h-12">
              {/* <MdOutlinePrivacyTip size={23} className="mt-2" /> */}
                {/* <SafetyCertificateOutlined className="mt-2" /> */}
              <p>Privacy & Security First</p>
            </div>
            <div className="md:h-12">
              {/* <IoSettingsOutline size={23} className="mt-2" /> */}
              {/* <SettingOutlined className="mt-2" /> */}
              <p>Support and Training.</p>
            </div>
            <div className="md:h-12">
              {/* <PiUsersThree size={27} className="mt-2" /> */}
               {/* <TeamOutlined className="mt-2" /> */}
              <p>User & Report Management</p>
            </div>
          </div>
        </div>
      </div>

      <div className="standoutFooter">
        <div>
          <h3 className="mb-2 text-base">Data Security</h3>
          <div className="standoutFooterData">
            <ul className="font-normal">
              <li>Data encryption with secured network</li>
              <li>Security audits regularly</li>
              <li>Secure cloud servers for data storage</li>
            </ul>
          </div>
        </div>
        <div>
          <h3 className="mb-2 text-base">Reliability</h3>
          <div className="standoutFooterReliability">
            <ul className="font-normal">
              <li>Efficient Operating time and availability</li>
              <li>Data recovery plans for handling any disaster situation.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StandOut;
